import Nav from './Nav.jsx';
import Hero from './Hero.jsx';

const capitalizeFirstLetter = (string) =>
  string.charAt(0).toUpperCase() + string.slice(1);

// Page chrome: document title, the fixed nav, and the hero. Every page renders
// exactly one of these.
const Header = ({
  title,
  heading,
  kicker,
  tagline,
  image,
  tall,
  plain,
  children,
}) => {
  // React 19 hoists <title> into <head> natively, so react-helmet is no longer
  // needed. scripts/prerender.js lifts it into the static HTML at build time.
  const pageTitle = `${title ? `${capitalizeFirstLetter(title)} | ` : ''}Amarpura`;

  return (
    <>
      <title>{pageTitle}</title>
      <Nav />
      <Hero
        kicker={kicker}
        heading={heading ?? title}
        tagline={tagline}
        image={image}
        tall={tall}
        plain={plain}
      >
        {children}
      </Hero>
    </>
  );
};

export default Header;
